<style scoped>
@media print {
  body * {
    visibility: hidden;
  }

  #modal-print,
  #modal-print * {
    visibility: visible;
  }

  #modal-print {
    position: absolute;
    inset: 0;
    background: white !important;
  }
}

</style>
<template>
  <!-- Fondo semitransparente -->
  <transition name="fade">
   <div
  v-if="visible"
  class="fixed inset-0 bg-black/50 backdrop-blur-sm
         flex items-center justify-center z-50 p-6"
>

  <!-- Modal -->
  <div
    class="bg-white  w-full h-full p-5 transform transition-all
           flex flex-col overflow-hidden"
    id="modal-print"
  >

    <!-- ================= HEADER ================= -->
    <div class="border-b p-5 flex justify-between items-start shrink-0">

      <div class="flex-1 text-center space-y-3">
        <div class="flex items-center justify-center">
          <img src="../../assets/logorwc.png" class="w-[220px]" />
        </div>

        <div class="grid grid-cols-2 gap-4 text-center">
          <div>
            <h2 class="text-xl font-semibold font-mono text-gray-800 tracking-wide">
              Historial modificación presupuesto {{ mesTexto }}
            </h2>
          </div>

          <div>
            <h2 class="text-xl font-semibold font-mono text-gray-800 tracking-wide">
              {{ nomcentro }} • {{ nomcta }}
            </h2>
          </div>
        </div>
      </div>

      <button
        @click="cerrar"
        class="text-gray-400 hover:text-gray-600 transition text-2xl leading-none ml-4"
      >
        ✕
      </button>
    </div>

    <!-- ================= CONTENIDO SCROLL ================= -->
    <div class="flex-1 overflow-y-auto">

      <table class="w-full text-md text-gray-700">
        <thead class="sticky top-0 bg-gray-50 z-10 shadow-sm">
          <tr class="border-b text-gray-600 font-mono">
            <th class="text-center py-2 px-2">id</th>
            <th class="text-center py-2 px-2">tipo</th>
            <th class="text-center py-2 px-2">fecha</th>
            <th class="text-center py-2 px-2">saldo inicial</th>
            <th class="text-center py-2 px-2">glosa</th>
            <th class="text-center py-2 px-2">aumento</th>
            <th class="text-center py-2 px-2">disminución</th>
            <th class="text-center py-2 px-2">saldo</th>
            <th class="text-center py-2 px-2">glosa movimientos</th>
            <th class="text-center py-2 px-2">comprobante</th>
            <th class="text-center py-2 px-2" v-if="this.$store.state.auth.userLogin.modifica_presupuestos">acción</th>
             
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(item,index) in datosMovimientos"
            :key="item.indice"
            class="border-b hover:bg-gray-50 font-mono"
            :class="{ 'bg-gray-50': index % 2 !== 0 }"
          >
            <td class="py-3 px-3 text-center">{{ item.id }}</td>
            <td class="py-3 px-3 text-center">{{ item.tipo }}</td>
            <td class="py-3 px-3 text-center">{{ item.fecha }}</td>
              <td class="py-3 px-3">  $ {{ $formatoMiles( item.saldo_inicial_fila) }}</td>
            <td class="py-3 px-3">{{ item.glosa }}</td>
            <td class="py-3 px-3 text-right">
              $ {{ $formatoMiles(item.monto_aumento) }}
            </td>
            <td class="py-3 px-3 text-right">
              $ {{ $formatoMiles(item.monto_disminucion) }}
            </td>
            <td class="py-3 px-3 text-right">
              $ {{ $formatoMiles(item.saldo) }}
            </td>
            <td class="py-3 px-3">
              <span class="text-sm" v-html="item.glosa_movimientos"></span>
            </td>
            <td class="py-3 px-3 text-center">
              <a
              v-if="item.id"
              :href="`${DJANGO_APP_API_URL}/api/v1/descargapdf/${item.id}/`"
              target="_blank"
              class="text-blue-600 hover:underline"
            >
              pdf
            </a>
            </td>

            <td v-if="this.$store.state.auth.userLogin.modifica_presupuestos">
                
            
                  <button v-if="item.id==ultimo_id_modificacion"
                    @click="reversar(item.id)"
                      title="reversar modificacion"
                    class="px-4  py-2 bg-red-500 text-white rounded-lg text-sm font-medium hover:bg-red-600 active:scale-95 transition"
                    >
                      Reversar 
                    </button>
            
            </td>
            <td></td>
          </tr>

          <!-- SALDO FINAL -->
          <tr class="bg-gray-100 font-semibold font-mono">
            <td colspan="7"></td>
            <td class="py-3 px-3 text-right">
              Saldo final: ${{ $formatoMiles(this.saldo) }}
            </td>
            <td colspan="2"></td>
          </tr>
        </tbody>
      </table>

    </div>

    <!-- ================= FOOTER ================= -->
    <div
      class="border-t p-4 flex justify-end space-x-4
             text-sm text-gray-600 shrink-0"
    >
      <button
        @click="cerrar"
        class="bg-gray-300 hover:bg-gray-200 text-gray-900
               px-6 py-2 rounded-lg shadow-sm"
      >
        Cerrar ventana
      </button>
<!-- 
      <button
        @click="print"
        class="bg-gray-300 hover:bg-gray-200 text-gray-900
               px-6 py-2 rounded-lg shadow-sm"
      >
        Imprimir
      </button> -->
    </div>

  </div>
</div>
  </transition>
</template>

<script>
 import api from "@/api/axios";

export default {
  name: "ModalHistorial",
 emits: [ "recarga_presupuestos_mensuales"], 
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    datos: {
      type: Object,
    },
    timestamp: {
      type: String,
    },
  },
  computed: {
    mesTexto() {
      const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      return this.mes > 0 ? meses[this.mes - 1] : "";
    },
  },
  watch: {
    // datosModificacion llegan por PROPS al cargar componente

    timestamp: function () {
      // this.recargaDatos(this.datosModificacion);
    },
    datos: function (v) {
      this.centro_id = v.centro_id;
      this.cuenta_id = v.cuenta_id;
      this.nommes = v.nommes;
      this.nomcentro = v.nomcentro;
      this.nomcta = v.nomcta;
      this.monto_mensual_ingreso = v.monto_mensual_ingreso;
      this.presupuesto_id = v.presupuesto_id;
      this.mes = v.mes;

      const ingreso = v.ingresos.filter((ing) => ing.mes == this.mes);
      const modificaciones = v.modificaciones.filter(
        (modif) => modif.mes == this.mes,
      );
      console.log(ingreso);
      console.log(modificaciones);
      this.datosMovimientos=[]
      /* 
      ingresos 
      [ { "id": 916, "mes": 4, "monto_mensual": "1100000.00", "glosa": "Importado desde CSV", "timestamp": "2025-12-29T12:32:42.008607-03:00", "presupuesto_id": 7630 } ]
      
      */

    let saldo=0;
    let saldo_inicial_modificaciones=0;
      if (Array.isArray(ingreso) && ingreso.length > 0) {
        this.datosMovimientos.push({
          indice: 0,
          tipo: ingreso[0].monto_mensual > 0 ? "Ingreso" : 'Sin ingreso',
          fecha: ingreso[0].monto_mensual > 0 ? this.formatearFecha(ingreso[0].timestamp) : '',
          glosa: ingreso[0].glosa,
          monto_ini: 0,
          monto_aumento: ingreso[0].monto_mensual,
          monto_disminucion: 0,
          saldo_inicial_fila: 0,
          saldo: ingreso[0].monto_mensual,
          file_url: ingreso[0].file_url

        });
        saldo = parseFloat(ingreso[0].monto_mensual);
        saldo_inicial_modificaciones = saldo;
      }

     if (Array.isArray(modificaciones)){
         /*
         {
[
    {
        "id": 71,
        "mes": 1,
        "timestamp": "2026-03-03T14:27:30.582774-03:00",
        "glosa": "Aumento Sueldo Oscar",
        "glosa_movimientos": "Disminucion; Administracion PV; Arriendo Inmuebles;4;200000.00<br>Disminucion; Administracion PV; Arriendo Inmuebles;7;100000.00<br>Disminucion; Administracion PV; Arriendo Inmuebles;9;200000.00",
        "presupuesto_mes_inicial": "10425000.00",
        "tipo_modificacion": 1,
        "monto": "500000.00",
        "file_url": "/uploads/modif_5_1_2026-03-03_1772558840592.xlsx",
        "con_reasignacion": false,
        "presupuesto": 5,
        "modificacionpadre": null,
        "user": 13
    },
    {
        "id": 75,
        "mes": 1,
        "timestamp": "2026-03-04T17:36:19.956623-03:00",
        "glosa": "",
        "glosa_movimientos": null,
        "presupuesto_mes_inicial": "10925000.00",
        "tipo_modificacion": 1,
        "monto": "1.00",
        "file_url": "/uploads/modif_5_1_2026-03-04_1772656579187.pdf",
        "con_reasignacion": false,
        "presupuesto": 5,
        "modificacionpadre": null,
        "user": 1
    },
    {
        "id": 99,
        "mes": 1,
        "timestamp": "2026-03-06T12:34:18.861704-03:00",
        "glosa": "reversa modificacion",
        "glosa_movimientos": null,
        "presupuesto_mes_inicial": "10924999.00",
        "tipo_modificacion": 2,
        "monto": "1.00",
        "file_url": null,
        "con_reasignacion": true,
        "presupuesto": 5,
        "modificacionpadre": null,
        "user": 1
    },
    {
        "id": 100,
        "mes": 1,
        "timestamp": "2026-03-06T12:35:11.838887-03:00",
        "glosa": "reversa modificacion",
        "glosa_movimientos": null,
        "presupuesto_mes_inicial": "9925000.00",
        "tipo_modificacion": 2,
        "monto": "500000.00",
        "file_url": null,
        "con_reasignacion": true,
        "presupuesto": 5,
        "modificacionpadre": null,
        "user": 13
    }
]
    } */ 
            for (const modif of  modificaciones)
              {

                  if (modif.tipo_modificacion == 1 ){
                         saldo+=parseFloat(modif.monto);
                  }else{
                     if (modif.tipo_modificacion == 2 ){
                          saldo-= parseFloat(modif.monto);
                     }
                  }

                  
                  let glosa_movimientos=''
                  if (modif.glosa_movimientos){
                          console.log(modif.glosa_movimientos)
                          let array =  modif.glosa_movimientos.split('<br>');
                          for(let i=0; i<  array.length;i++){
                          
                              // Disminución,Administracion PV, Agua, 1, $500.00
                              //  tipo , C.C, Cuenta, monto, 
                            
                              let glosa = array[i].split(";");
                              let nommes =glosa[3] >0 ? this.meses[glosa[3]  - 1] : '';
                              let modificacion_padre = glosa[6] ? glosa[6]: '';
                              glosa_movimientos += "<tr>"
                                  +"<td>"+ modificacion_padre+"</td>"
                                            +"<td>"+glosa[0]+"</td>"
                                          +"<td class='px-1'>" + glosa[1]+"</td>"
                                           +"<td class='px-1'>" + glosa[2]+"</td>"
                                           +"<td class='px-1'>" + nommes+"</td>"
                                           +"<td class='px-1'>$" + glosa[4]+"</td></tr> ";
                          }
                         
                  }

                  if (glosa_movimientos){
                    glosa_movimientos = "<table class='w-full text-md text-gray-700' cellpadding=1 cellspacing=1 border=1>"+ glosa_movimientos + "</table>";
                  }
                   

                    this.datosMovimientos.push({
                    id: modif.id,
                    indice: 0,
                    tipo:  modif.tipo_modificacion == 1 ? 'Aumento':'Disminución',
                    fecha: this.formatearFecha(modif.timestamp) ,
                    movimientos:modif,
                    glosa: modif.glosa,
                    glosa_movimientos:  glosa_movimientos,
                    monto_ini: 0,
                    monto_aumento:  modif.tipo_modificacion == 1 ? modif.monto : '',
                    monto_disminucion:   modif.tipo_modificacion == 2 ? modif.monto : '',
                    saldo_inicial_fila:saldo_inicial_modificaciones,
                    saldo: saldo,
                    file_url: modif.file_url
                  });
                  saldo_inicial_modificaciones=saldo;
                   this.ultimo_id_modificacion=modif.id;
                 
                  
            }


     }

     this.saldo = saldo;
    },

  
  },
  methods: {
    print(){
      window.print()
    },
    cerrar() {
      this.$emit("update:visible", false);
    },  
    formatearFecha(timestamp) {
      const fecha = new Date(timestamp);

      const dd = String(fecha.getDate()).padStart(2, "0");
      const mm = String(fecha.getMonth() + 1).padStart(2, "0");
      const yyyy = fecha.getFullYear();

      const hh = String(fecha.getHours()).padStart(2, "0");
      const mi = String(fecha.getMinutes()).padStart(2, "0");
      const ss = String(fecha.getSeconds()).padStart(2, "0");

      return `${dd}/${mm}/${yyyy} ${hh}:${mi}:${ss}`;
    },
    async reversar(modificacion_id)
    {
      if (!confirm('¿confirmar reversa modificacion? ')){
        return false;
      }


      const data = {
        modificacion_id: modificacion_id 
      }
      try {   
     
        const response = await api.post("api/v1/reversarmodificacion/", data, {
             headers: {
            "Content-Type": "application/json",

          },
        });
         console.log(response);
      
        this.$emit("recarga_presupuestos_mensuales");
        this.cerrar()
      } catch (e) {
        console.error("Credenciales inválidas ❌",e);
      }
    }
  },
  data() {
    return {
      loading: false,
      ingresos: [],
      modificaciones: [],
      meses: [
        "Ene.",
        "Feb.",
        "Mar.",
        "Abr.",
        "May.",
        "Jun.",
        "Jul.",
        "Ago.",
        "Sept.",
        "Oct.",
        "Nov.",
        "Dic.",
      ],

      mes: 0,
      nomcentro: "",
      nomcta: "",
      nommes: " ",
      presupuesto_id: 0,
      centro_id: 0,
      cuenta_id: 0,
      datosMovimientos: [],
      saldo:0,
      DJANGO_APP_API_URL:'',
      ultimo_id_modificacion:0
    };
    /**
     * list_movimientos
     * 
     [{
        "indice":0,
        "centro":37,
        "centro_datos":"VCO069000000000 - Amigos del Parque Pumalin",
        "cuenta":32,
        "cuenta_datos":"4.5.1030.40.15 - Alimentación animales de trabajo",
        "objMesMonto":{
          "mes":5,
          "monto":4
        }
     }]
     */
  },
  mounted() {
    this.DJANGO_APP_API_URL = process.env.VUE_APP_DJANGO_API_URL
    this.datosMovimientos=[]
  },
};
</script>

 
